'use strict';

/**
*        
*   ---=== FlexTools ===---
*   https://zhangfisher.github.com/flex-tools
* 
*   一些实用工具函数
*
*/
function o(e){if(typeof e!="object"||e===null)return !1;var r=Object.getPrototypeOf(e);if(r===null)return !0;for(var t=r;Object.getPrototypeOf(t)!==null;)t=Object.getPrototypeOf(t);return r===t}

exports.a = o;
